import { render, staticRenderFns } from "./RedsysResult.vue?vue&type=template&id=37f35f5a&scoped=true"
import script from "./RedsysResult.vue?vue&type=script&lang=js"
export * from "./RedsysResult.vue?vue&type=script&lang=js"
import style0 from "./RedsysResult.vue?vue&type=style&index=0&id=37f35f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f35f5a",
  null
  
)

export default component.exports